import { useEffect, useRef, useState } from "react";

// SVG Imports
import BackToTop from "../../../../assets/landingPage/TopArrow.svg";
import AbhayRangnekar from "../../../../assets/landingPage/AbhayRangnekar.png";
import AkshaySirWeb from "../../../../assets/landingPage/AkshaySirWeb.jpg";
import AkshaySirMob1 from "../../../../assets/landingPage/AkshaySirMob1.png";
import AnkurSirWeb from "../../../../assets/landingPage/AnkurSirWeb.jpg";
import AnkurSirMob1 from "../../../../assets/landingPage/AnkurSirMob1.png";
import AshishSirWeb from "../../../../assets/landingPage/AshishSirWeb.jpg";
import AshishSirMob1 from "../../../../assets/landingPage/AshishSirMob1.png";
import MilindKothari from "../../../../assets/landingPage/MilindKothari.png";
import VijayAdvani from "../../../../assets/landingPage/VijayAdvani.png";
import RohitVerma from "../../../../assets/landingPage/RohitVerma.png"
import AjayMulgaokar from "../../../../assets/landingPage/AjayMulgaokar.png";
import AmitTambe from "../../../../assets/landingPage/AmitTambe.png";
import SantoshNene from "../../../../assets/landingPage/SantoshNene.png";
import JagdeepKapoor from "../../../../assets/landingPage/JagdeepKapoor.png";
import SamridhKapoor from "../../../../assets/landingPage/SamridhKapoor.png";
import MathiasBPontoppidan from "../../../../assets/landingPage/Mathias_B_Pontoppidan.jpg";

// COMPONENTS Imports
import Footer from "../../../../components/LandingPage/Footer";
import ExpandingCards from "../../../../components/_utils/ExpandingCards/ExpandingCards";

// MUI Import
import { CircularProgress, Typography } from "@mui/material";
import ICONS from "../../../../assets/Icons";
import SVGComponent from "../../../../components/_utils/SVGComponent";

const Advisors = () => {
  const boardAdvisors = [
    {
      name: "Abhay Rangnekar",
      image: AbhayRangnekar,
      alt: "AbhayRangnekar",
      content: `Abhay Rangnekar founded Quest2travel.com in 2000 to develop a web-based platform enabling large organizations to manage end-to-end employee travel online in real-time, covering approvals, bookings (air, hotel, car, rail, etc.), and expense claims.\nQuest2travel secured its first client in 2007, broke even by 2010, cleared accumulated losses by 2013, and has remained profitable since-achieving growth without external investors or bank debt. This 100% ownership allowed Abhay to secure a strategic partnership and stake sale with Nasdaq-listed MakeMyTrip, finalized in September 2023.\nQuest2travel’s long-standing clients include top corporations in India, such as the Aditya Birla Group, Times of India Group, JSW Group, Airtel, HDFC Life, Tata Motors, SBI General, and RBI. Today, with over 400 clients, Quest2travel is a leader in corporate travel in India.\nIn addition, Abhay founded Quest2Pay (a pioneer in vendor payments via virtual corporate cards) in 2016 and Q2Pay Technologies in 2018.\nAbhay plays a key role in guiding strategy and advisory functions at Xpentra.`,
    },
    {
      name: "Milind Kothari",
      image: MilindKothari,
      alt: "MilindKothari",
      content: `Milind is the Managing Partner of BDO in India, a leading global professional services organization offering tax, accounting, assurance, digital services and advisory services. Milind leads the India firm of 300+ Partners & Directors and 9000+ people working across 12 strategic cities servicing clients from diverse industries worldwide.\nHe has over 40 years of experience in handling critical Tax, Transfer Pricing, Cross-Border Tax & Transaction Advisory engagements.\nHe is an empaneled author with Business World for monthly columns and op-eds on leadership, strategy, business philosophy and organizational culture. He is dedicated to delivering value to all stakeholders through providing exceptional client service with quality at the core.\nHis focus on furthering the use of technology in the accounting profession has led him to become one of the visionaries and pioneers in the tax-tech space.\nMilind is helping Xpentra in establishing robust financial controls and creating value.`,
    },
    {
      name: "Vijay Advani",
      image: VijayAdvani,
      alt: "VijayAdvani",
      content: `Vijay has over two decades of experience in investment management, financial market development, and strategic growth.\nAs CEO and Executive Chairman of Nuveen from 2017 to 2020, he led the firm’s strategic direction and mergers.\nPrior to this, he has served as Co-President of Franklin Templeton, focusing on growth initiatives, M&A, and investment management and spent 11 years at the World Bank, advising governments on developing financial markets and structuring financing solutions.\nCurrently, Vijay is a board member and trustee for Fidelity Mutual Funds, a senior advisor to Seviora Holdings and Neuberger Berman, and a former Chairman Emeritus of the USIBC. He also advises The Hive Incubator and serves on the board of the Global Impact Investing Network.\nIn his current role, Vijay is instrumental in guiding our global expansion strategy.`,
    },
    {
      name: "Jagdeep Kapoor",
      role: "Marketing & Brand Strategy",
      image: JagdeepKapoor,
      alt: "AmitTambe",
      content: `Jagdeep Kapoor is the Founder and Chairman of Samsika Marketing Consultants and Samsika Academy, and the founder of India’s first integrated Brand and Marketing Strategy consulting firm. He has advised leading organisations across industries on brand strategy, positioning, and marketing effectiveness.
Mr. Kapoor is a Visiting Professor of Marketing Management and Brand Management at JBIMS and SP Jain School of Global Management. He is also the author of 14 books and textbooks on Marketing Strategy and Brand Management, widely regarded for their relevance to the Indian business context.
He supports Xpentra by advising on brand positioning, go-to-market strategy, and building a strong, differentiated market presence.`,
    },
    {
      name: "Samridh Kapoor",
      role: "Marketing & Sales",
      image: SamridhKapoor,
      alt: "SamridhKapoor",
      content: `Samridh Kapoor is an investor and the Proprietor of Samridh Kapoor® Capital, a sector-agnostic capital allocation firm founded in 2010. He deploys proprietary capital using value-investing principles and has been an early investor across portfolio companies in IP Strategy, Martech, Enterprise Consulting, Edtech, Market Research, and AI.
Samridh is an inventor with over 15 USPTO-issued utility patents and was a recipient of the National Intellectual Property Award (2018) for Patents and Commercialisation from the Government of India. He has been a Visiting Faculty member at NMIMS and NMCCE since 2019, teaching Behavioural Finance and Behavioural Economics. Samridh has studied Finance, Management, and Economics at the University of Mumbai.
Samridh provides support to Xpentra on Go-To-Market and Salesforce Enablement.`,
    },
  ];
  const strategicAdvisors = [
    {
      name: "Ajay Mulgaokar",
      role: "Technology Operations",
      image: AjayMulgaokar,
      alt: "AjayMulgaokar",
      content: `Ajay is an experienced technology and business operations leader, with over 35 years of multi-faceted experience in building and running large Managed Services, global Technology and Operations businesses across HR / Human capital domain. 
He has held leadership roles at leading technology-first organizations such as Wipro, Aon Hewitt, Alight Solutions and IMR Global. He has managed multi-geography business teams with spans of up to 5000+ full-time employees. He has been instrumental in building domain capability and building strategic technology products for leading HCM platforms.
Ajay’s expertise lies in standing up and scaling technology and business operations centers (captive as well as 3rd party) globally. In his previous roles, he has helped expand business globally, acquiring new logos and growing existing relationships.
He is advising Xpentra on building at scale in an efficient, robust manner.`,
    },
    {
      name: "Amit Tambe",
      role: "Legal Council",
      image: AmitTambe,
      alt: "AmitTambe",
      content: `Amit Tambe is an independent legal practitioner based in Mumbai, specializing in corporate law with a focus on mergers and acquisitions, private equity and venture capital. Amit’s expertise also extends to navigating complex regulatory landscapes, ensuring seamless compliance across jurisdictions.

Prior to starting his independent practice, Amit was a partner at Trilegal looking after the mergers and advisory practice.
Amit’s advisory experience spans both domestic and multi-national players across industries ranging from fintechs/startups to Financial Services majors and conglomerates. A select list of his clients includes DEI Global (a Fairfax company), Flipkart, eBay, Eruditus Education, Godrej Group, Sumitomo Corporation, Deutsche Bank, Sequoia Capital, and Goldman Sachs. He has a proven track record of providing innovative legal solutions tailored to align with business objectives.

Amit helps provide strategic direction and guidance on regulatory as well as legal requirements for Xpentra.`,
    },
    {
      name: "Santosh Nene",
      role: "Asset Management",
      image: SantoshNene,
      alt: "SantoshNene",
      content: `A seasoned asset management industry veteran, Santosh has spent 20+ years setting up and growing AMC operations across entities in India.
As SVP and Head of PMS operations at ING, he handled business challenges ranging from regulatory compliance, risk management to  operational excellence. In this role, Santosh helped build a culture of service quality and customer orientation, while helping drive post merger integration of acquired business units.
Santosh has also helped build robust operational capabilities at firms such as UTI-Investor Services.
He is an acknowledged expert in fund operations and client management, with a thorough understanding of operations-centered statutory and compliance requirements for the asset management industry.
Building on his deep understanding of the challenges that the asset management industry faces, he is helping define and execute our value proposition for AMCs, wealth managers and fund houses in India.`,
    },
    {
      name: "Mathias B. Pontoppidan",
      role: "European Expansion",
      image: MathiasBPontoppidan,
      alt: "MathiasBPontoppidan",
      content: `Mathias is the founder and Managing Partner of Pontoka, an investment and sustainability advisory firm working with leading LP's, GP's, corporates and private banks across India, Europe and the US, with offices in Copenhagen and Mumbai.

Having operated in India since 2012 and with a background spanning investment banking (M&A and PE), hedge funds and fintech advisory, the India-European corridor has remained a consistent focus throughout his career.

Mathias is supporting the management in strategising and co-executing on Xpentra's European expansion plans.`,
    },
    {
      name: "Rohit Verma",
      role: "Chief Risk Officer",
      image: RohitVerma,
      alt: "RohitVerma",
      content: `Rohit is Chief Risk Officer at Q2Pay Technologies. Rohit has over 26 years of industry-wide experience in designing, implementing and auditing enterprise-wide Governance, Risk and Compliance Frameworks for Business Continuity Management, IT Disaster Recovery, Third Party Risk Management, Enterprise Risk Management, Information Security, Cyber Resilience, Health and Safety.
During his 18+ years in client-facing roles at EY, KPMG, and IBM, he worked in global positions, contributing to world-class practices in Governance, Risk and Compliance in above Domains.
Rohit has held Management level positions, including General Manager – Resilience Services in IBM, Business Continuity Management Head in Deutsche Bank – South East Asia and Enterprise Resilience Head in Barclays Bank – India and Indonesia, providing strategic direction for these Functions. 
Rohit holds multiple industry-recognized certifications, including CBCP, CRP, CDRE, ISO 22301:2019 LA, CISA, CISSO, ISO 27001 LA, CA, MBA, PGDFPS and FSAIAP, as his commitment to continuous learning and excellence in the field.`,
    },
  ];
  const aboutSections = [
    {
      id: 1,
      profileWeb: AkshaySirWeb,
      profileMob: AkshaySirMob1,
      name: "Akshay Rangnekar",
      title: "Founder and Chief Executive Officer",
      description: `Akshay has always been passionate about technology, with an innate inclination to innovate and automate. After earning his bachelor’s degree in computer engineering at Cal Poly, he worked at a Silicon Valley startup for 2 years. He returned to India in 2016, recognizing India’s push towards digitization and technological transformation. There, he contributed to Quest2Pay (a pioneer in vendor payments via virtual corporate cards) and built GST and expense management solutions for Quest2Travel before founding Xpentra, a universal banking solution for enterprise customers. He designs core functionality, database structures, business logic, user interfaces, and process flows for both web and mobile platforms.`,
    },
    {
      id: 2,
      profileWeb: AnkurSirWeb,
      profileMob: AnkurSirMob1,
      name: "Ankur Rangnekar",
      title: "Co-founder and Chief Operating Officer",
      description: `Ankur, based out of Mumbai, co-founded Xpentra after heading to Bay Area and Singapore for advanced studies. The "Make in India" initiative and the possibilities offered by the Indian economy inspired him to return to the country. He takes care of operations, manages customer and partner relationships, and helps drive business development and strategic initiatives within the organization.`,
    },
    {
      id: 3,
      profileWeb: AshishSirWeb,
      profileMob: AshishSirMob1,
      name: "Ashish Wadekar",
      title: "Chief Technology Officer",
      description: `Ashish is a seasoned tech leader with a diverse international career. He began his journey in Pune and later moved to Zürich, where he led a successful ERP implementation for RitikaaWood, demonstrating his capability in managing complex software projects. Known for his innovative approach, Ashish consistently develops creative solutions to meet evolving business needs. Since joining Q2Pay in 2022, he has been instrumental in driving the company's technological vision, inspiring and leading teams with his expertise and passion.`,
    },
  ];

  // useRef
  const containerRef = useRef(null);
  const containerRef1 = useRef(null);

  // useState
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);
  const [openBoardAdvisorIndex, setOpenBoardAdvisorIndex] = useState(null);
  const [openStrategicAdvisorIndex, setOpenStrategicAdvisorIndex] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);

  // useSelector
  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  const handleBoardOpenModal = (index) => {
    setOpenBoardAdvisorIndex(index);
    setOpenStrategicAdvisorIndex(null);
    setSelectedCard(boardAdvisors[index]);
    setIsModalOpen(true);
  };

  const handleBoardCloseModal = () => {
    setOpenBoardAdvisorIndex(null);
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  const handleStrategicOpenModal = (index) => {
    setOpenStrategicAdvisorIndex(index);
    setOpenBoardAdvisorIndex(null);
    setSelectedCard(strategicAdvisors[index]);
    setIsModalOpen(true);
  };

  const handleStrategicCloseModal = () => {
    setOpenStrategicAdvisorIndex(null);
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  const handleScroll = (containerRef, setIndex) => {
    if (!containerRef.current) return;

    const container = containerRef.current;
    const cards = container.children;

    const containerCenter =
      container.scrollLeft + container.offsetWidth / 2;

    let closestIndex = 0;
    let closestDistance = Infinity;

    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];

      const cardCenter =
        card.offsetLeft + card.offsetWidth / 2;

      const distance = Math.abs(cardCenter - containerCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    }

    setIndex(closestIndex);
  };

  // useEffect
  useEffect(() => {
    if (!containerRef.current) return;
    const element2 = containerRef.current;
    const handleScroll2 = () => handleScroll(containerRef, setCurrentIndex);
    element2.addEventListener("scroll", handleScroll2);

    return () => {
      element2.removeEventListener("scroll", handleScroll2);
    };
  }, []);

  useEffect(() => {
    if (!containerRef1.current) return;
    const element1 = containerRef1.current;
    const handleScroll1 = () => handleScroll(containerRef1, setCurrentIndex1);
    element1.addEventListener("scroll", handleScroll1);

    return () => {
      element1.removeEventListener("scroll", handleScroll1);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    });
  }, [scrollPercent]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "36px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}

        <div className={`bg-[#031f4f] ${
          isModalOpen
            ? "overflow-y-hidden lg:overflow-y-auto"
            : openBoardAdvisorIndex !== null || openStrategicAdvisorIndex !== null
              ? "lg:overflow-y-hidden"
              : ""
        }`}
          style={{
            height: "100vh",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <div className="lg:hidden py-[30px] bg-[#102c5d] flex flex-col gap-[15px] mt-[60px]">
            <div className="px-[30px] text-font-md font-semibold text-text-primary">
              <span className="text-pending">Leadership</span> team
            </div>
            <div
              ref={containerRef}
              className="px-[30px] mx-auto flex gap-[10px] max-w-full overflow-x-auto"
              style={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
              }}
            >
              {aboutSections.map((section, index) => (
                <div
                  key={index}
                  className="rounded-[10px] bg-[#244277] px-[10px] py-[10px] w-[290px] flex-shrink-0 h-auto flex flex-col gap-[10px]"
                >
                  <div>
                    <img
                      className="mx-auto w-[280px] rounded-t-[10px]"
                      src={section.profileMob}
                      alt="leader"
                    />
                  </div>
                  <div className="flex flex-col gap-[5px] text-text-primary px-[10px] pt-[10px]">
                    <div className="text-font-md font-semibold">{section.name}</div>
                    <div className="text-font-xs font-normal pb-[10px] border-b-[1px]">
                      {section.title}
                    </div>
                  </div>
                  <div className="px-[10px] text-text-primary">
                    <div className="text-font-xs font-normal overflow-y-auto">
                      {section.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="max-w-[230px] mx-auto mt-[10px] flex gap-[10px] justify-center">
              {aboutSections.map((_, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setCurrentIndex(index);
                    containerRef.current.children[index].scrollIntoView({
                      behavior: "smooth",
                      block: "nearest",
                      inline: "center",
                    });
                  }}
                  className={`rounded-[18px] cursor-pointer bg-white h-[4px] transition-all duration-500 ease-in-out ${
                    index === currentIndex ? "w-[80px] opacity-100" : "w-[40px] opacity-50"
                  }`}
                ></div>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex justify-center items-center mt-[30px]">
            <div className="flex flex-col text-text-primary py-[30px] px-20 mx-auto max-w-[1024px]">
              <div className="text-font-xl font-semibold text-text-primary text-center pb-[20px] pt-[30px]">
                <span className="text-pending">Leadership</span> team
              </div>
              <ExpandingCards data={aboutSections} />
            </div>
          </div>

          <div className="p-[30px] lg:pt-[20px] lg:pb-[30px] lg:m-0 lg:p-0 bg-[#031f4f]
            lg:bg-[linear-gradient(270deg,rgb(3,31,79)_0%,rgb(28,58,109)_27%,rgb(34,64,116)_78%,rgb(3,31,79)_100%,rgb(35,65,118)_100%)] bg-no-repeat"
          >
            <div
              className="flex flex-col lg:flex-row items-stretch text-text-primary mx-auto lg:py-[30px]"
              style={{ maxWidth: "1024px" }}
            >
              {/* Mission */}
              <div className="bg-[#244277] border border-pending rounded-[15px] flex flex-col items-center w-full p-[20px] lg:p-0">
                <div>
                  <img src={ICONS?.MISSION} alt="mission" className="w-[50] h-[50px] mb-[20px] lg:my-5" />
                </div>
                <div className="title-div text-base font-semibold mb-[5px] lg:mb-0">
                  Our <span className="text-pending">mission</span>
                </div>
                <div className="text-text-primary text-xs lg:p-4 lg:pt-[10px]">
                  At Xpentra, our mission is to empower businesses by providing seamless,
                  integrated solutions that optimise financial management and treasury
                  operations. We aim to give companies complete visibility and control
                  over their finances through a unified platform that simplifies complex
                  processes, improves decision-making, and drives efficiency. By
                  bridging the gap between multiple banking systems and financial
                  workflows, we help businesses stay agile, efficient, and ready for the
                  future.
                </div>
              </div>

              <div className="flex items-center self-center mx-auto rotate-90 lg:rotate-0 lg:w-[80px] lg:h-[80px]">
                <img src={ICONS?.CONNECTOR_LEFT} alt="ConnectArrowLeft" className="w-[20px] h-[20px] lg:hidden" />
                <img src={ICONS?.CONNECTOR_LEFT} alt="ConnectArrowLeft" className="hidden lg:block lg:w-[80px] lg:h-[80px]" />
              </div>

              {/* Vision */}
              <div className="bg-[#244277] border border-pending rounded-[15px] flex flex-col items-center w-full p-[20px] lg:p-0">
                <div>
                  <img src={ICONS?.VISION} alt="vission" className="w-[50] h-[50px] mb-[20px] lg:my-5" />
                </div>
                <div className="title-div text-base font-semibold mb-[5px] lg:mb-0">
                  Our <span className="text-pending">vision</span>
                </div>
                <div className="text-text-primary text-xs lg:p-4 lg:pt-[10px]">
                  Our vision is to transform how businesses make decisions by providing a
                  platform that simplifies and automates financial operations, giving
                  CXOs the real-time insights they need to act quickly and confidently.
                  We aim to empower organisations with smarter tools that streamline
                  processes and enhance decision-making across all areas of the
                  business. We envision a future where businesses operate with greater
                  agility, efficiency, and clarity, enabling them to achieve lasting
                  success.
                </div>
              </div>

              <div className="flex items-center self-center mx-auto rotate-90 lg:rotate-0 lg:w-[80px] lg:h-[80px]">
                <img src={ICONS?.CONNECTOR_RIGHT} alt="ConnectArrowRight" className="w-[20px] h-[20px] lg:w-[80px] lg:h-[80px]" />
              </div>

              {/* Values */}
              <div className="bg-[#244277] border border-pending rounded-[15px] flex flex-col items-center w-full p-[20px] lg:p-0">
                <div className="mb-[20px] lg:my-5">
                  <img src={ICONS?.VALUES} alt="values" className="w-[50] h-[50px]" />
                </div>
                <div className="title-div text-base font-semibold mb-[5px] lg:mb-0">
                  Our <span className="text-pending">values</span>
                </div>
                <div className="text-text-primary text-xs lg:p-4 lg:pt-[10px]">
                  {[
                    ["Transparency", "We believe in open and clear communication, offering complete visibility into every transaction and financial process."],
                    ["Reliability", "Our platform is built to deliver consistent, secure, and dependable performance for businesses managing their financial operations."],
                    ["User-Centric", "We prioritise intuitive, easy-to-use solutions that are tailored to meet the specific needs of each business, ensuring a smooth experience."],
                    ["Security", "Xpentra places a strong emphasis on safeguarding all data and transactions with industry- leading protocols and fraud protection."],
                  ].map(([title, copy]) => (
                    <div className="mb-[5px] lg:mb-2.5" key={title}>
                      • <span className="font-medium" style={{ WebkitTextStroke: "0.3px white", letterSpacing: "0.2px" }}>{title}</span>: {copy}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="px-[30px] flex flex-col gap-2.5 text-text-primary bg-[#031f4f]">
            <div className="h-full max-w-[1440px] w-full flex flex-col gap-[30px] justify-center mx-auto lg:max-w-[1024px] lg:items-center">
              <div className="w-full flex flex-col justify-center lg:items-center">
                <h3 className="text-font-md lg:text-font-xl font-semibold text-text-primary text-left lg:text-center pt-0 lg:pt-[30px]">
                  Meet our <span className="text-pending">advisors</span>
                </h3>
                <p className="text-font-xs lg:text-sm mt-5 lg:mt-2.5 lg:text-center lg:max-w-[1024px]">
                  At Xpentra, we believe that innovation thrives when backed by
                  experience and expertise. While our journey has been defined by
                  cutting-edge technology and customer-centric solutions, our growth
                  is shaped by the wisdom and strategic direction of industry
                  leaders. Discover the experts behind our success.
                </p>
              </div>
            </div>
          </div>

          <div className="py-[30px] lg:pt-[72px] lg:pb-[61px] flex flex-col gap-5 text-text-primary bg-[#031f4f]">
            <div className="px-[30px] text-font-md font-semibold text-text-primary lg:hidden">
              Board <span className="text-pending">advisors</span>
            </div>

            <div className="lg:hidden">
              <div
                ref={containerRef1}
                className="px-[30px] mx-auto flex gap-[20px] max-w-full overflow-x-auto"
                style={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                {boardAdvisors.map((section, index) => (
                    <div
                      key={index}
                      className="rounded-[10px] bg-[#244277] w-[300px] flex-shrink-0 h-auto flex flex-col gap-[10px]"
                    >
                      <div>
                        <img
                          className="mx-auto rounded-t-[10px]"
                          src={section.image}
                          alt={section.name}
                        />
                      </div>
                      <div className="flex flex-col gap-[5px] text-text-primary px-[10px]">
                        <div className="text-font-md font-semibold">{section.name}</div>
                      </div>
                      <div className="px-[10px] text-text-primary">
                        <div
                          className="text-font-xs font-normal overflow-y-auto overflow-hidden text-ellipsis line-clamp-4"
                          onClick={toggleContent}
                        >
                          {section.content}
                        </div>
                      </div>
                      <div
                        className="w-[112px] h-9 rounded-[5px] p-2.5 mx-2.5 mb-2.5 bg-text-primary flex justify-between cursor-pointer"
                        onClick={() => handleBoardOpenModal(index)}
                      >
                        <div className="text-[#031f4f] text-font-xs h-4 font-semibold">
                          Read More
                        </div>
                        <div className="h-3.5 w-3.5 my-auto">
                          <SVGComponent
                            url={ICONS?.ARROW_RIGHT_WHITE}
                            height={"var(--icon-md)"}
                            width={"var(--icon-md)"}
                            color={"var(--text-primary)"}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              {isModalOpen && (
                <div
                  className="fixed inset-0 bg-custom-backdrop bg-opacity-75 flex justify-center items-center z-50 overflow-hidden -bottom-2"
                  onClick={handleBoardCloseModal}
                >
                  <div className="bg-[#244277] relative pb-[10px] sm:pb-0 rounded-[10px] w-[300px] sm:w-[80%] h-[80vh] sm:h-auto max-w-[600px] cursor-default overflow-hidden">
                    <div className="absolute right-[10px] top-[10px]">
                      <img
                        className="h-[30px] w-[30px]"
                        src={ICONS?.CLOSE_WITH_BLUE_SQUARE}
                        alt="close_with_blue_square"
                      />
                    </div>
                    <div
                      className="flex flex-col flex-shrink-0 sm:flex-row items-center h-[100vh] sm:h-[299px] overflow-auto sm:overflow-hidden"
                      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <div>
                        <img src={selectedCard.image} alt={selectedCard.name} />
                      </div>
                      <div className="sm:max-h-[299px] sm:w-[330px]">
                        <div className="text-font-md font-bold w-full text-left pb-1.5 pl-2.5">
                          {selectedCard.name}
                        </div>
                        <div
                          className="mt-2.5 text-font-xs text-text-primary h-max overflow-y-auto sm:h-[245px] px-2.5 border-t-[1px]"
                          style={{ paddingBottom: "10px" }}
                        >
                          {selectedCard.content}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="max-w-[230px] mx-auto mt-[10px] flex gap-[10px] justify-center">
                {boardAdvisors.map((section, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setCurrentIndex1(index);
                        containerRef1.current.children[index].scrollIntoView({
                          behavior: "smooth",
                          block: "nearest",
                          inline: "center",
                        });
                      }}
                      className={`rounded-[18px] cursor-pointer bg-text-primary h-[4px] transition-all duration-500 ease-in-out ${
                        index === currentIndex1 ? "w-[80px] opacity-100" : "w-[40px] opacity-50"
                      }`}
                    ></div>
                  ))}
              </div>
            </div>

            <div className="hidden lg:flex mx-auto justify-center">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-[30px] 
                gap-y-[30px] place-items-center">
                <div
                  className="flex items-center justify-start"
                  style={{ width: "322px", height: "374px" }}
                >
                  <p className="text-text-primary text-6xl font-semibold text-left leading-tight">
                    <span>Board</span>
                    <br />
                    <span className="text-pending">advisors</span>
                  </p>
                </div>

                {boardAdvisors.map((boardAdvisor, index) => (
                  <div key={index}>
                    <div
                      className="bg-[#314d7e] rounded-t-2xl rounded-b-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300 ease-in-out cursor-pointer"
                      style={{ width: "322px", height: "374px" }}
                      onClick={() => handleBoardOpenModal(index)}
                    >
                      <img
                        src={boardAdvisor.image}
                        className="h-80 w-full rounded-t-2xl"
                        alt={boardAdvisor.alt}
                      />

                      <p className="text-text-primary text-center py-[15px] text-base">
                        {boardAdvisor.name}
                      </p>
                    </div>

                    {openBoardAdvisorIndex === index && (
                      <>
                        <div className="fixed w-screen top-0 left-0 h-screen bg-custom-backdrop opacity-95 z-[2147483647]" />

                        <div
                          className="flex justify-center items-center m-auto top-1/2 left-1/2 fixed z-[2147483647]"
                          style={{ transform: "translate(-50%, -50%)" }}
                        >
                          <div
                            className="relative flex flex-col gap-4 bg-custom-appBackLight rounded-2xl"
                            style={{
                              width: "914px",
                              height: "auto",
                              paddingBottom: "30px",
                              paddingLeft: "30px",
                              paddingRight: "30px",
                            }}
                          >
                            <div className="flex justify-between items-center w-full">
                              <div style={{ width: "80%" }} />

                              <div className="flex justify-end w-[20%] mt-6 hover:opacity-70 hover:cursor-pointer">
                                <img
                                  src={ICONS?.CLOSE_WITH_BLUE_SQUARE}
                                  className="cursor-pointer w-[33px]"
                                  onClick={handleBoardCloseModal}
                                  alt="Close"
                                />
                              </div>
                            </div>

                            <div className="flex flex-row gap-6 -mt-2">
                              <div
                                className="flex-shrink-0 bg-[#314d7e] rounded-2xl shadow-lg"
                                style={{ flexBasis: "35%", height: "90%" }}
                              >
                                <img
                                  src={boardAdvisor.image}
                                  className="h-[85%] w-full rounded-t-2xl"
                                  alt={boardAdvisor.alt}
                                />

                                <p className="text-text-primary text-center py-[15px] text-base">
                                  {boardAdvisor.name}
                                </p>
                              </div>

                              <div className="flex flex-col text-text-primary text-sm gap-y-4 leading-[1.5]">
                                {boardAdvisor.content.split("\n").map((line, idx) => (
                                  <div key={idx}>{line}</div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="py-[30px] flex flex-col gap-2.5 text-text-primary"
            style={{ background: "linear-gradient(90deg, #031F4F 0%, #224074 50%, #031F4F 100%)" }}
          >
            <div className="px-[30px] text-font-md lg:text-2xl font-semibold text-text-primary lg:text-center lg:pb-5">
              Strategic <span className="text-pending">advisors</span>
            </div>

            <div className="lg:hidden">
              <div
                className="px-[30px] mx-auto flex gap-[20px] max-w-full overflow-x-auto"
                style={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                {strategicAdvisors.map((section, index) => (
                  <div
                    key={index}
                    className="rounded-[10px] bg-[#314d7e] w-[260px] flex-shrink-0 h-auto flex flex-col gap-[10px] border-[2px] border-pending"
                    onClick={() => handleStrategicOpenModal(index)}
                  >
                    <div className="border-b-[2px] border-b-pending">
                      <img
                        className="mx-auto w-[280px] rounded-t-[10px]"
                        src={section.image}
                        alt="leader"
                      />
                    </div>
                    <div className="flex justify-between px-[10px] pb-[10px] cursor-pointer">
                      <div className="flex flex-col gap-gap-xs">
                        <div className="flex flex-col gap-[5px] text-text-primary">
                          <div className="text-font-md font-semibold">{section.name}</div>
                        </div>
                        <div className="text-text-primary">
                          <div className="text-font-xs font-normal">{section.role}</div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className="rounded-[5px] flex justify-between items-center">
                          <SVGComponent
                            url={ICONS?.ARROW_RIGHT_WHITE}
                            height={"var(--icon-sm)"}
                            width={"var(--icon-sm)"}
                            color={"var(--text-primary)"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {isModalOpen && (
                <div
                  className="fixed inset-0 bg-custom-backdrop bg-opacity-75 flex justify-center items-center z-50 overflow-hidden -bottom-2"
                  onClick={handleStrategicCloseModal}
                >
                  <div className="bg-[#244277] relative pb-[10px] sm:pb-0 rounded-[10px] w-[300px] sm:w-[80%] h-[80vh] sm:h-auto max-w-[600px] cursor-default overflow-hidden">
                    <div className="absolute right-[10px] top-[10px] cursor-pointer">
                      <img
                        className="h-[30px] w-[30px]"
                        src={ICONS?.CLOSE_WITH_BLUE_SQUARE}
                        alt="close_with_blue_square"
                      />
                    </div>
                    <div
                      className="flex flex-col flex-shrink-0 sm:flex-row items-center h-[80vh] sm:h-[299px] overflow-auto sm:overflow-hidden"
                      style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <div>
                        <img src={selectedCard.image} alt={selectedCard.name} />
                      </div>
                      <div className="sm:max-h-[299px] sm:w-[330px]">
                        <div className="text-font-md font-bold w-full text-left pt-2.5 pl-2.5">
                          {selectedCard.name}
                        </div>
                        <div
                          className="mt-2.5 text-font-xs text-text-primary overflow-y-auto sm:h-[245px] px-2.5 border-t-[1px]"
                          style={{ paddingBottom: "10px" }}
                        >
                          <div className="mt-2.5">{selectedCard.content}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="hidden lg:flex mx-auto justify-center">
              <div
                className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 mx-auto gap-x-[30px] gap-y-[30px] place-items-center"
                style={{ maxWidth: "1024px" }}
              >
                {strategicAdvisors.map((strategicAdvisor, index) => (
                  <div key={index}>
                    <div
                      className="bg-[#314d7e] rounded-t-[18px] rounded-b-2xl shadow-lg hover:shadow-xl hover:scale-105 transition-transform duration-300 ease-in-out cursor-pointer"
                      style={{ width: "188px", height: "257px", border: "2px solid var(--pending)" }}
                      onClick={() => handleStrategicOpenModal(index)}
                    >
                      <img
                        src={strategicAdvisor.image}
                        className="h-70 w-full rounded-t-2xl"
                        alt={strategicAdvisor.alt}
                      />
                      <div className="flex flex-col gap-gap-xs">
                        <p
                          className="text-text-primary text-center pt-[15px] text-sm"
                          style={{ borderTop: "2px solid var(--pending)" }}
                        >
                          {strategicAdvisor.name}
                        </p>
                        <p className="text-text-primary text-center pb-[15px] text-xs">
                          {strategicAdvisor.role}
                        </p>
                      </div>
                    </div>
                    {openStrategicAdvisorIndex === index && (
                      <>
                        <div className="fixed w-screen top-0 left-0 h-screen bg-custom-backdrop opacity-95 z-[2147483647]"></div>
                        <div
                          className="flex justify-center items-center m-auto top-1/2 left-1/2 fixed z-[2147483647]"
                          style={{ transform: "translate(-50%, -50%)" }}
                        >
                          <div
                            className="relative flex flex-col gap-4 bg-custom-appBackLight rounded-2xl"
                            style={{
                              width: "914px",
                              height: "auto",
                              paddingBottom: "30px",
                              paddingLeft: "30px",
                              paddingRight: "30px",
                            }}
                          >
                            <div className="flex justify-between items-center w-full">
                              <div style={{ width: "80%" }}></div>
                              <div className="flex justify-end w-[20%] mt-5 hover:opacity-70 hover:cursor-pointer">
                                <img
                                  src={ICONS?.CLOSE_WITH_BLUE_SQUARE}
                                  className="cursor-pointer w-[33px]"
                                  onClick={handleStrategicCloseModal}
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="flex flex-row gap-6 -mt-4">
                              <div
                                className="flex-shrink-0 bg-[#314d7e] rounded-t-2xl rounded-b-2xl shadow-lg"
                                style={{ flexBasis: "35%" }}
                              >
                                <img
                                  src={strategicAdvisor.image}
                                  className="h-auto w-full rounded-t-2xl"
                                  alt={strategicAdvisor.name}
                                />
                                <p className="text-text-primary text-center pt-[15px] text-base">
                                  {strategicAdvisor.name}
                                </p>
                                <p className="text-text-primary text-center pb-[15px] text-xs">
                                  {strategicAdvisor.role}
                                </p>
                              </div>
                              <div className="flex flex-col gap-[12px] text-text-primary text-sm leading-[1.5] min-h-80">
                                {strategicAdvisor.content
                                  .split("\n")
                                  .filter((line) => line.trim() !== "")
                                  .map((line, idx) => (
                                    <div key={idx}>
                                      {line}
                                      <br />
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Advisors;
